module.exports = __webpack_public_path__ + "static/img/business_licence.e50f463.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/business_licence.png
// module id = 1380
// module chunks = 1